import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logout" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[0] || (_cache[0] = _createTextVNode(" You're logged in as ")),
      _createElementVNode("b", null, _toDisplayString($data.session?.tokens?.idToken?.payload?.email), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, "User id is " + _toDisplayString($data.user?.userId), 1 /* TEXT */),
    _createElementVNode("div", null, "Cognito pool is " + _toDisplayString($data.cognito_pool), 1 /* TEXT */),
    _createElementVNode("div", null, "Backend url is " + _toDisplayString($data.backend_url), 1 /* TEXT */),
    _createVNode(_component_Button, {
      primary: "",
      onClick: $options.logout
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("Log Out")
      ])),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ]))
}